import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import { Box, Button, Card, Chip, IconButton, Stack, styled, Typography } from '@mui/material';
import DialogSelectRoles from './DialogSelectRoles';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';
import { firestore } from '../../../../../contexts/FirebaseContext';

function MethodSection({ dataConf, generalActualSetting }) {
  const [selectedRoles, setSelectedRoles] = useState([]);
  // const [generalSett, setGeneralSett] = useState({});
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const confId = dataConf.id;
  const generalActualSettingId = generalActualSetting.id;

  const handleDeleteRoles = (rol) => {
    const newRolesArr = selectedRoles.filter((rolItem) => rolItem !== rol);
    setSelectedRoles(newRolesArr);
  };

  const addRoles = (idRol) => {
    setSelectedRoles([...selectedRoles, idRol]);
  };

  const saveNewConf = async () => {
    setLoading(true);

    const localMethod = generalActualSetting.methods.find((meth) => meth.id === confId);
    const filterMethodArr = generalActualSetting.methods.filter((meth) => meth.id !== confId);

    const newObj = { ...localMethod, allowedUserRole: selectedRoles };
    const newArrMethodConf = [...filterMethodArr, newObj];

    console.log('el metodo actualizado', newArrMethodConf);

    try {
      await firestore.collection('settings_conf').doc(generalActualSettingId).update({ methods: newArrMethodConf });
      enqueueSnackbar('Guardado', { variant: 'success' });

      setLoading(false);
    } catch (error) {
      enqueueSnackbar('Se ha producido un error', { variant: 'error' });

      setLoading(false);
    }
  };

  useEffect(() => {
    const selected = dataConf.allowedUserRole;
    setSelectedRoles(selected);
    // setGeneralSett(generalSetting);
  }, [dataConf]);
  return (
    <Card sx={{ padding: '15px', marginBottom: '10px' }}>
      <Box sx={{ display: 'flex', gap: '15px', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="subtitle1">{dataConf.name}</Typography>
        <DialogSelectRoles selectedRoles={selectedRoles} addRoles={addRoles} />
      </Box>
      <Card sx={{ padding: '10px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        {selectedRoles.length ? (
          <>
            {selectedRoles.map((rol) => (
              <Chip key={rol} label={rol} onDelete={() => handleDeleteRoles(rol)} />
            ))}
          </>
        ) : (
          <Typography>No hay roles asignados</Typography>
        )}
      </Card>
      <LoadingButton
        loading={loading}
        variant="contained"
        onClick={saveNewConf}
        size="small"
        sx={{ marginTop: '10px' }}
      >
        guardar
      </LoadingButton>
    </Card>
  );
}

export default MethodSection;
